// extracted by mini-css-extract-plugin
export default {"container":"skills_container__+Ztdd","box_skills":"skills_box_skills__583ht","box":"skills_box__JvMbu","icon":"skills_icon__9DzTE"};